/* eslint-disable array-callback-return */
import * as yup from "yup";
import regEx from "./regularExpression";

const validationSchema: any = {
  firstName: yup
    .string()
    .trim("First name cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "First name must be more than 2 characters")
    .max(30, "First name cannot exceed more than 30 characters")
    .required("First name is a required field")
    .matches(regEx.alphabetsOnly, "Only alphabets are allowed for this field"),

  lastName: yup
    .string()
    .matches(regEx.alphabetsOnly, "Only alphabets are allowed for this field")
    .trim("Last name cannot include leading and trailing spaces")
    .strict(true)
    .min(1, "Last name must be more than 1 characters")
    .max(30, "Last name cannot exceed more than 30 characters")
    .required("Last name is a required field"),
  email: yup
    .string()
    .trim("Email cannot include leading and trailing spaces")
    .strict(true)
    .email("Invalid Email format")
    .matches(regEx.email, "Invalid Email format")
    .min(2, "Email must be more than 2 characters")
    .max(60, "Email cannot exceed more than 60 characters")
    .required("Email is a required field"),
  password: yup.string().required("Password is a required field"),
};

export const getValidationSchema = (fields: string[]) => {
  const newValidationSchema: any = {};

  fields.map((fieldName) => {
    newValidationSchema[fieldName] = validationSchema[fieldName];
  });

  return yup.object().shape(newValidationSchema);
};
